module.exports = __webpack_public_path__ + "img/img-9.c637d587.png";